import type { FC } from 'react';
import { WarningIcon } from '@THC/components/Icons';
import { MDText } from 'i18n-react';

import type { ChatItem } from 'Features/AiCompanion/services';

import LocalTexts from '../../AiCompanion.texts';

import styles from './ErrorItem.module.scss';

const LocalT = new MDText(LocalTexts);

interface ErrorItemProps {
	item: ChatItem;
}

export const ErrorItem: FC<ErrorItemProps> = () => {
	return (
		<div className={styles.content}>
			<WarningIcon data-error-icon />
			<div>{LocalT.translate('chatItem.error')}</div>
		</div>
	);
};
